export const scrollToId = (id, offset = 0, behavior = 'smooth') => {
  setTimeout(() => {
    const el = document.getElementById(id);
    if (el) {
      const elementTop = el.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementTop - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: behavior,
      });
    }
  }, 50);
};
